import { Input, Label, Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';

function SeccionCentroContacto({
  formik,
  formationCenter,
  fidelitationlist,
  idCedesca,
  idCntec,
}) {
  return (
    <>
      <Row className="mt-2">
        <Col md="2">
          <Label htmlFor="centro">
            <small>
              Centro <span className="text-danger">*</span>
            </small>
          </Label>
          <Input
            id="centro"
            name="centro"
            type="select"
            onChange={formik.handleChange}
            className={formik.errors.centro ? 'border border-danger error' : ''}
            disabled={idCedesca > 0 && idCntec > 0}
            value={formik.values.centro}
          >
            {formationCenter !== ''
              ? formationCenter.map((option) => (
                  <option key={`${option.Id}-centro`} value={option.Id}>
                    {option.Nombre}
                  </option>
                ))
              : ''}
          </Input>
          {formik.errors.centro ? (
            <div className="text-danger tiny">{formik.errors.centro}</div>
          ) : null}
        </Col>
        <Col md="2">
          <Label htmlFor="sexo">
            <small>
              Sexo <span className="text-danger">*</span>
            </small>
          </Label>
          <Input
            id="sexo"
            name="sexo"
            type="select"
            onChange={formik.handleChange}
            value={formik.values.sexo}
            className={formik.errors.sexo ? 'border border-danger error rounded ' : ''}
          >
            <option key="0-sexo" value="0"></option>
            <option key="1-sexo" value="1">Hombre</option>
            <option key="2-sexo" value="2">Mujer</option>
            <option key="3-sexo" value="3">No binario</option>
          </Input>
          {formik.errors.sexo ? (
            <div className="text-danger tiny">{formik.errors.sexo}</div>
          ) : null}
        </Col>
        <Col md="2">
          <Label htmlFor="emailPers">
            <small>
              Email <span className="text-danger">*</span>
            </small>
          </Label>
          <Input
            id="emailPers"
            name="emailPers"
            type="email"
            onChange={formik.handleChange}
            value={formik.values.emailPers}
            className={formik.errors.emailPers ? 'border border-danger error' : ''}
          />
          {formik.errors.emailPers ? (
            <div className="text-danger tiny">{formik.errors.emailPers}</div>
          ) : null}
        </Col>
        <Col md="2">
          <Label htmlFor="telefono">
            <small>Teléfono</small>
          </Label>
          <Input
            id="telefono"
            name="telefono"
            type="text"
            onChange={formik.handleChange}
            value={formik.values.telefono}
          />
        </Col>
        <Col md="2">
          <Label htmlFor="movil">
            <small>
              Móvil <span className="text-danger">*</span>
            </small>
          </Label>
          <Input
            id="movil"
            name="movil"
            type="text"
            onChange={formik.handleChange}
            value={formik.values.movil}
            className={formik.errors.movil ? 'border border-danger error' : ''}
          />
          {formik.errors.movil ? (
            <div className="text-danger tiny">{formik.errors.movil}</div>
          ) : null}
        </Col>
        <Col md="2">
          <Label htmlFor="conocer">
            <small>
              ¿Cómo nos has conocido? <span className="text-danger">*</span>
            </small>
          </Label>
          <Input
            id="conocer"
            name="conocer"
            type="select"
            onChange={formik.handleChange}
            value={formik.values.conocer}
            className={formik.errors.conocer ? 'border border-danger error' : ''}
          >
            {fidelitationlist !== ''
              ? fidelitationlist.map((option) => (
                  <option key={`${option.id}`} value={option.nom}>
                    {option.nom}
                  </option>
                ))
              : ''}
          </Input>
          {formik.errors.conocer ? (
            <div className="text-danger tiny">{formik.errors.conocer}</div>
          ) : null}
        </Col>
      </Row>
      <Row>
        <Col className="mt-2" md="2">
          <Label htmlFor="dndconocer">
            <small>¿Dónde nos has conocido?</small>
          </Label>
          <Input
            id="dndconocer"
            name="dndconocer"
            type="text"
            onChange={formik.handleChange}
            value={formik.values.dndconocer}
            className={formik.errors.dndconocer ? 'border border-danger error' : ''}
          />
        </Col>
      </Row>
    </>
  );
}

SeccionCentroContacto.propTypes = {
  formik: PropTypes.object.isRequired,
  formationCenter: PropTypes.array.isRequired,
  fidelitationlist: PropTypes.array.isRequired,
  idCedesca: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  idCntec: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default SeccionCentroContacto;
